module.exports = __webpack_public_path__ + "fonts/VetoSans-Light.2c7d0dd9.eot";